import { render, staticRenderFns } from "./AffiliationMicrosite.vue?vue&type=template&id=5c7e2058&scoped=true"
import script from "./AffiliationMicrosite.vue?vue&type=script&lang=js"
export * from "./AffiliationMicrosite.vue?vue&type=script&lang=js"
import style0 from "./AffiliationMicrosite.vue?vue&type=style&index=0&id=5c7e2058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7e2058",
  null
  
)

export default component.exports